/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Card_SaveInputs */

const en_directory_card_save = /** @type {(inputs: Directory_Card_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save product`)
};

const zh_directory_card_save = /** @type {(inputs: Directory_Card_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收藏产品`)
};

/**
* | output |
* | --- |
* | "Save product" |
*
* @param {Directory_Card_SaveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_save = /** @type {((inputs?: Directory_Card_SaveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_SaveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_save(inputs)
	return zh_directory_card_save(inputs)
});
export { directory_card_save as "directory.card.save" }